var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"how-it-works__list__item",attrs:{"data-component":"HowItWorksItem"}},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":"Image"}})]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.$ml.get(_vm.description)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }